// pages/findings/[domain]/[year]/[slug]/[version].js
// ════════════════════════════════════════════════════════════════════
// LAB FINDING — versioned canonical route (Phase F6)
//
// Renders a specific version of a finding. URL format:
//   /findings/<domain>/<year>/<slug>/<version>
// Examples:
//   /findings/strategic/2026/asymmetric-underdog-inversion/v1
//   /findings/popdec/2026/korea-hungary-divergence/v1
//
// Citation handles point at this route shape:
//   lab:finding/strategic/2026/asymmetric-underdog-inversion/v1
//   resolves to /findings/strategic/2026/asymmetric-underdog-inversion/v1
//
// 404s for any (domain, year, slug, version) combination not in the
// registry — including version mismatches.
// ════════════════════════════════════════════════════════════════════

import Head from 'next/head';
import { FINDING_REGISTRY, getFinding } from '../../../../../features/findings/registry';

export default function FindingVersionedPage({ findingKey }) {
  const entry = findingKey ? FINDING_REGISTRY[findingKey] : null;

  if (!entry) return null;

  const Component = entry.component;
  const { meta } = entry;

  return (
    <div className="sp-root">
      <Head>
        <title>{meta.pageTitle}</title>
        {meta.description && <meta name="description" content={meta.description} />}
        <link
          rel="canonical"
          href={`/findings/${meta.domain}/${meta.year}/${meta.slug}/${meta.version}`}
        />
      </Head>
      <Component />
    </div>
  );
}

export async function getStaticPaths() {
  const paths = Object.keys(FINDING_REGISTRY).map((key) => {
    const [domain, year, slug, version] = key.split('/');
    return { params: { domain, year, slug, version } };
  });
  return { paths, fallback: false };
}

export async function getStaticProps({ params }) {
  const { domain, year, slug, version } = params;
  const entry = getFinding(domain, year, slug, version);
  if (!entry) return { notFound: true };
  const findingKey = `${domain}/${year}/${slug}/${version}`;
  return { props: { findingKey } };
}
